/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Services_AllInputs */

const en_landing_services_all = /** @type {(inputs: Landing_Services_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All sessions`)
};

const pl_landing_services_all = /** @type {(inputs: Landing_Services_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie zajęcia`)
};

/**
* | output |
* | --- |
* | "All sessions" |
*
* @param {Landing_Services_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_services_all = /** @type {((inputs?: Landing_Services_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Services_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_services_all(inputs)
	return en_landing_services_all(inputs)
});